import React, { useEffect, useState } from "react";
import { Brain, Sparkle, Wrench } from "@phosphor-icons/react";
import { api } from "../lib/api";

const ICONS = {
  ORCHESTRATOR: Brain,
  SME: Sparkle,
  UTILITY: Wrench,
};

const ACCENT = {
  ORCHESTRATOR: "text-fuchsia-400 border-fuchsia-500/30",
  SME:          "text-emerald-400 border-emerald-500/30",
  UTILITY:      "text-sky-400 border-sky-500/30",
};

export default function IntelligenceRouterFooter() {
  const [tiers, setTiers] = useState(null);
  useEffect(() => { api.router().then(d => setTiers(d.tiers)).catch(() => setTiers([])); }, []);

  return (
    <footer
      data-testid="router-footer"
      className="bg-slate-950 border-t border-slate-800 px-6 py-4"
    >
      <div className="tracking-mono-label text-[10px] text-slate-500 mb-3">
        Procureo Intelligence Tiers
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {!tiers && Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-16 skeleton rounded-sm" />
        ))}
        {tiers?.map((t) => {
          const Icon = ICONS[t.tier];
          return (
            <div
              key={t.tier}
              data-testid={`router-tier-${t.tier.toLowerCase()}`}
              className={`flex items-center gap-3 border bg-slate-900 px-4 py-3 rounded-sm ${ACCENT[t.tier]}`}
            >
              <Icon weight="duotone" size={24} />
              <div className="min-w-0">
                <div className="font-display text-sm font-semibold text-slate-50 truncate">
                  {t.label}
                </div>
                <div className="text-[11px] text-slate-400 truncate">{t.purpose}</div>
                <div className="text-[10px] tracking-mono-label text-slate-500 mt-0.5">
                  {t.tier} Tier
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </footer>
  );
}
